import React from 'react'
import { Modal, Button } from '../ui'

function MaxProductsModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Product limit reached</Modal.Title>
      </Modal.Header>
      <Modal.Body>Sorry, you can only add 10 products per mixture.</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default MaxProductsModal